import {withComponent} from '../../hoc/withComponent';
import {TableTitleBase} from './TableTitleBase';

export const withTableTitle = withComponent(TableTitleBase);
